// ###### IMPORTS
import { useState, useCallback } from 'react';

// ###### CONSTANTS
const STORAGE_KEY = 'notepad_collapsed_clusters';
const DEFAULT_STATE = {};

// ###### CUSTOM HOOK
export const useCollapsedClusters = () => {
  const [collapsedClusters, setCollapsedClustersState] = useState(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      return saved ? JSON.parse(saved) : DEFAULT_STATE;
    } catch (error) {
      console.error('Error reading collapsed clusters from localStorage:', error);
      return DEFAULT_STATE;
    }
  });

  const toggleCollapse = useCallback((clusterId) => {
    setCollapsedClustersState(prev => {
      const newState = {
        ...prev,
        [clusterId]: !prev[clusterId]
      };
      
      // Save to localStorage
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(newState));
      } catch (error) {
        console.error('Error saving collapsed clusters to localStorage:', error);
      }
      
      return newState;
    });
  }, []);

  return { collapsedClusters, toggleCollapse };
};
